var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48784",
    "data-name": "Group 48784",
    transform: "translate(-466.5 -417.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(466.5 417.5)",
    fill: "#1f143d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(472.5 417.5)",
    fill: "#1f143d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(478.5 417.5)",
    fill: "#1f143d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsblack);
export default __webpack_public_path__ + "static/media/dotsblack.c3f50443cf1ea14213307166865f78c3.svg";
export { ForwardRef as ReactComponent };